<div class="order-payments">
  @if (Loading) {
  <div class="muted">Loading…</div>
  } @else {

  <table class="pay-table">
    <thead>
      <tr>
        <th class="num">Paid</th>
        <th>Payment Date</th>
        <th>Method</th>
        <th>Bank</th>
        <th>Stage</th>
      </tr>
    </thead>
    <tbody>
      @for (p of Payments; track $index) {
      <tr [class.negative]="p.Amount < 0">
        <td class="num">{{ p.Amount | currency: 'USD' : 'symbol' : '1.2-2' }}</td>
        <td>{{ p.PaymentDate | date: 'MM/dd/yyyy' : 'UTC' }}</td>
        <td>{{ p.MethodName ?? '—' }}</td>
        <td>{{ p.BankName ?? '—' }}</td>
        <td>
          <span class="stage stage-{{ (p.AccountingStage ?? '').toString().toLowerCase().replace(' ', '-') }}">
            {{ p.AccountingStage ?? p.StatusName }}
          </span>
        </td>
      </tr>
      } @empty {
      <tr>
        <td colspan="5" class="muted">No payments on this order yet.</td>
      </tr>
      }
    </tbody>
  </table>

  @if (Summary) {
  <div class="totals">
    <div><span>Order total</span> {{ Summary.OrderTotal | currency: 'USD' : 'symbol' : '1.2-2' }}</div>
    <div><span>Total paid</span> {{ Summary.TotalPaid | currency: 'USD' : 'symbol' : '1.2-2' }}</div>
    @if ((Summary.PendingPaid ?? 0) !== 0) {
    <div><span>Processing</span> {{ Summary.PendingPaid | currency: 'USD' : 'symbol' : '1.2-2' }}</div>
    }
    <div class="left"><span>Left to pay</span> {{ Summary.LeftToPay | currency: 'USD' : 'symbol' : '1.2-2' }}</div>
  </div>
  }

  <div class="actions">
    <button class="btn-bg-green" type="button" [disabled]="!canPayMore" (click)="openPartial()">Open Partial Pay Window</button>
    <button class="btn-bg-slate" type="button" (click)="close()">Close</button>
  </div>
  }
</div>
